/**
 * makeContact mutation — document and types are generated by codegen (see codegen.ts).
 * This file maps ContactMeSubmitPayload to the generated MakeContactMutationVariables.
 */
import type { MakeContactMutationVariables } from '../gql/graphql'
import type { ContactMeSubmitPayload } from '../../types'

export { MakeContactDocument } from '../gql/graphql'

export function toMakeContactVariables(
  payload: ContactMeSubmitPayload,
  propertyId?: string
): MakeContactMutationVariables {
  return {
    data: {
      email: payload.email,
      phone: payload.phone || undefined,
      message: payload.message || undefined,
      source: payload.source,
      acceptPrivacyPolicy: payload.acceptPrivacyPolicy,
      acceptMarketing: payload.acceptMarketing,
      utm_source: payload.utm_source,
      personalData: {
        set: {
          firstname: payload.firstName || undefined,
          lastname: payload.lastName || undefined,
          phone: payload.phone || undefined,
          email: payload.email,
          country: payload.country || undefined,
        },
      },
      notes: {
        set: [`Has WhatsApp: ${payload.hasWhatsApp}`, `message: ${payload.message}`].filter(
          note => note
        ),
      },
      ...(propertyId ? { property: { connect: { id: propertyId } } } : {}),
    },
  }
}
